import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import ProtectPage from './pages/ProtectPage';
import SharePage from './pages/SharePage';
import ExtendPage from './pages/ExtendPage';
import MultiplyPage from './pages/MultiplyPage';

const App: React.FC = () => (
  <Router>
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/protect" element={<ProtectPage />} />
        <Route path="/share" element={<SharePage />} />
        <Route path="/extend" element={<ExtendPage />} />
        <Route path="/multiply" element={<MultiplyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </Layout>
  </Router>
);

export default App;
